var Mn = require('backbone.marionette'),
    scope = require('scope'),
    helpers = require('../libs/helpers');
module.exports = scope.views.Default =  Mn.View.extend({
    onAttach: function () {
        // console.log("ATTACH DA VIEW")
        helpers.anchor(0);
    }
});



//////////////////
// WEBPACK FOOTER
// ./resources/assets/site/scripts/views/Default.js
// module id = 231
// module chunks = 3